import { Model } from '@vuex-orm/core'

export class NewsChannel extends Model {
  static entity = 'newsChannel'
  static primaryKey = ['news_id', 'channel_id']

  static fields () {
    return {
      news_id: this.number(null),
      channel_id: this.number(null)
    }
  }
}

export default NewsChannel
